import { Component, OnInit, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { MailTemplatesService } from '../services/mail-templates.service';
import { LoadingPanelService } from 'src/app/shared/loading-panel/loading-panel.service';
import { Router } from '@angular/router';
import { MailTemplate } from '../models/mail-template';
import { ColumnButtonClickEvent, RowDblClickEvent } from 'devextreme/ui/data_grid';
import { DxDataGridModule } from 'devextreme-angular';
import { SvgIconComponent } from 'src/app/shared/icons/svg-icon.component';
import { BizDataGridDirective } from 'src/app/shared/grid/biz-grid.directive';
import { PermissionRequiredDirective } from 'src/app/shared/authentication/permission-required.directive';

import { CurrentUserService } from 'src/app/user/services';
import { ChangeLogLinkComponent } from 'src/app/shared/change-log/change-log-link/change-log-link.component';
import { ChangeLogLinkEntityDirective } from 'src/app/shared/change-log/change-log-link-entity/change-log-link-entity.directive';
import { BizGridFiltervalues } from 'src/app/shared/grid/biz-grid-filtervalues';
import { BizUserColumnDirective } from 'src/app/shared/grid/biz-grid-user.directive';
import { BizDateColumnDirective } from 'src/app/shared/grid/biz-grid-date.directive';

@Component({
  selector: 'app-mail-templates-list',
  templateUrl: './mail-templates-list.component.html',
  styleUrl: './mail-templates-list.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SvgIconComponent, ChangeLogLinkComponent, ChangeLogLinkEntityDirective, DxDataGridModule, BizDataGridDirective, PermissionRequiredDirective, BizUserColumnDirective, BizDateColumnDirective]
})
export class MailTemplatesListComponent implements OnInit {
  private router = inject(Router);
  private mailTemplatesService = inject(MailTemplatesService);
  private currentUserService = inject(CurrentUserService);
  private loadingPanelService = inject(LoadingPanelService);

  allowUpdating: boolean = this.currentUserService.hasPermission('Mail_Action_Template_Edit');

  mailTemplates = signal<MailTemplate[]>([]);

  constructor(public bizGridFiltervalues: BizGridFiltervalues) {}

  ngOnInit(): void {
    void this.refresh()
  }

  async refresh(): Promise<void> {
    try {
      this.loadingPanelService.showLoadingPanelDirect('Loading...');
      const [mailTemplates] = await Promise.all([
        this.mailTemplatesService.getMailTemplates()
      ]);
      this.mailTemplates.set(mailTemplates);
    }
    finally {
      this.loadingPanelService.hideLoadingPanel();
    }
  }

  onEditButtonClick = (e: ColumnButtonClickEvent) => {
    this.editMailTemplate(e.row.data as MailTemplate, 'edit')
  };

  onRowDblClick = (e: RowDblClickEvent) => {
    if (this.allowUpdating) {
      this.editMailTemplate(e.data as MailTemplate)
    }
  };

  editMailTemplate(mailTemplate: MailTemplate, mode: string = 'edit') {
    const mailTemplateId = mailTemplate.Id;
    void this.router.navigate(['settings/mail-templates/details', { mailTemplateId, mode }]);
  };

  calculateSubjectDisplayValue(rowData: MailTemplate){
    if(rowData.UseCustom) {
      return rowData.CustomSubject
    } else {
      return rowData.Subject
    }
  }

  calculateUsingDisplayValue(rowData: MailTemplate){
    if(rowData.UseCustom) {
      return 'Custom'
    } else {
      return 'Default'
    }
  }
}
